import React, { useState, useEffect } from "react";
import { 
  FormControlLabel, 
  Switch, 
  Typography, 
  Box,
  IconButton
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CustomTooltip from "./CustomTooltip";

const PreTransactionFilter = ({ 
  onChange = () => {},
  defaultChecked = null,
  label = "Exclude pre-transactions associated with transactions",
  tooltipText = "If you turn it on, you won't see the pre-transactions that have been moved to a transaction."
}) => {
  const [excludePreTransactions, setExcludePreTransactions] = useState(
    defaultChecked !== null ? defaultChecked : false
  );

  // Update local state when defaultChecked prop changes (e.g., after database fetch)
  useEffect(() => {
    if (defaultChecked !== null) {
      setExcludePreTransactions(defaultChecked);
    }
  }, [defaultChecked]);

  const handleChange = (event) => {
    const isChecked = event.target.checked;
    setExcludePreTransactions(isChecked);
    onChange(isChecked);
  };

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        marginLeft: 'auto',
      }}
    >
      <FormControlLabel
        control={
          <Switch
            checked={excludePreTransactions}
            onChange={handleChange}
            color="primary"
            size="small"
            sx={{
              '& .MuiSwitch-switchBase.Mui-checked': {
                color: '#001E29',
              },
              '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                backgroundColor: '#001E29',
              }
            }}
          />
        }
        label={
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography 
              variant="body2" 
              color="textPrimary"
              sx={{ 
                fontSize: '0.875rem',
                fontWeight: 400,
                marginLeft: 0.5
              }}
            >
              {label}
            </Typography>
            
            <CustomTooltip 
              title={tooltipText} 
              arrow
              placement="top-end"
              enterDelay={500}
              leaveDelay={200}
              PopperProps={{
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [20, 0],
                    },
                  },
                ],
              }}
            >
              <IconButton 
                size="small" 
                sx={{ 
                  color: '#637177',
                  '&:hover': {
                    backgroundColor: '#EEF5F8',
                    '@media (hover: none)': {
                        backgroundColor: 'transparent',
                      },
                  },
                  '& .MuiSvgIcon-root': {
                    marginRight: '0px',
                  },
                }}
              >
                <InfoOutlinedIcon sx={{ fontSize: '16px' }} />
              </IconButton>
            </CustomTooltip>
          </Box>
        }
        labelPlacement="end"
        sx={{ 
          margin: 0,
          display: 'flex',
          alignItems: 'center'
        }}
      />
    </Box>
  );
};

export default PreTransactionFilter;
